module.exports = __webpack_public_path__ + "img/miscellaneous.5b168a0c.png";